import type { PropsWithChildren, ReactNode } from 'react';
import { motion } from 'framer-motion';

import { defaultMotionProps } from '../motion';

export const Testimonial = ({
  company,
  quote,
  author,
  children,
}: PropsWithChildren<{
  company: ReactNode;
  quote: string;
  author: ReactNode;
}>) => {
  return (
    <section className="bg-cipher-04 relative overflow-hidden py-180 ml:py-220">
      {children}
      <motion.div
        className="max-w-[980px] mx-auto px-30 flex flex-col gap-16 ml:gap-55 text-cloud z-10 relative"
        {...defaultMotionProps}
        variants={{
          initial: {},
          animate: {
            transition: {
              staggerChildren: 0.15,
            },
          },
        }}
      >
        <motion.div
          className="flex items-center justify-center ml:justify-start"
          variants={{
            initial: {
              opacity: 0,
              y: 20,
            },
            animate: {
              opacity: 1,
              y: 0,
            },
          }}
          transition={defaultMotionProps.transition}
        >
          {company}
        </motion.div>
        <motion.blockquote
          className="font-planar ml:text-[32px] text-[16px] font-light leading-[150%] [text-indent:-0.5em] text-center ml:text-left"
          variants={{
            initial: {
              opacity: 0,
              y: 20,
            },
            animate: {
              opacity: 1,
              y: 0,
            },
          }}
          transition={defaultMotionProps.transition}
        >
          &ldquo;{quote}&rdquo;
        </motion.blockquote>
        <motion.p
          className="ml:text-[21px] text-[14px] font-light leading-[150%] text-center ml:text-left"
          variants={{
            initial: {
              opacity: 0,
              y: 20,
            },
            animate: {
              opacity: 1,
              y: 0,
            },
          }}
          transition={defaultMotionProps.transition}
        >
          {author}
        </motion.p>
      </motion.div>
    </section>
  );
};
